import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Button, Input } from "antd";

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 4,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 20,
        },
    },
};
const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 20,
            offset: 4,
        },
    },
};

export default function DynamicField({disabled=false}) {
    return (
        <Form.List
            name="contactNumbers"
            rules={[
                {
                    validator: async (_, contactNumbers) => {
                        if (!contactNumbers || contactNumbers.length < 1) {
                            return Promise.reject(new Error('Please provide at least 1 contact number'));
                        }
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>

                    {fields.map((field, index) => (
                        <Form.Item
                            {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                            label={index === 0 ? 'Contact Number' : ''}
                            required={false}
                            key={field.key}
                        >
                            <Form.Item
                                {...field}
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please input contact number or delete this field.",
                                    },
                                ]}
                                noStyle
                            >
                                <Input
                                    placeholder="Contact number"
                                    style={{
                                        width: '30%',
                                    }}
                                    disabled={disabled}
                                />
                            </Form.Item>
                            {fields.length > 1 ? (
                                <MinusCircleOutlined
                                    className="dynamic-delete-button"
                                    onClick={() => remove(field.name)}
                                />
                            ) : null}
                        </Form.Item>
                    ))}
                    <Form.Item>
                        <Button
                            type="dashed"
                            onClick={() => add()}
                            style={{
                                width: '25%',
                            }}
                            icon={<PlusOutlined />}
                            disabled={disabled}
                        >
                            Add contact
                        </Button>
                        <Form.ErrorList errors={errors} />
                    </Form.Item>
                </>
            )}
        </Form.List>
    )
}
